import PropTypes from 'prop-types';
import { IconHelpSquareRounded, IconSpeakerphone } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Popover } from '@mantine/core';
import classes from './title.module.css';

const Title = (props) => {
  const {
    title,
    subtitle,
    hideNews = false,
    hideHelp = false,
  } = props;

  const { t } = useTranslation();

  const info = (title || subtitle)
    ? (
      <div className={classes.info}>
        {title && <h1 data-f="pageTitle" dangerouslySetInnerHTML={{ __html: title }} />}
        {subtitle && <h2 dangerouslySetInnerHTML={{ __html: subtitle }} />}
      </div>
    )
    : null;

  const actions = (!hideNews || !hideHelp)
    ? (
      <div className={classes.actions}>
        {(!hideNews) ? (
          <Popover width={300} position="bottom-end">
            <Popover.Target>
              <button className={classes.action}>
                <span className={classes.icon}><IconSpeakerphone stroke={1.5} /></span>
                <span className={classes.label}>{t('components.head.action.news')}</span>
              </button>
            </Popover.Target>
            <Popover.Dropdown></Popover.Dropdown>
          </Popover>
        ) : null}
        {(!hideNews) ? (
          <Popover width={300} position="bottom-end">
            <Popover.Target>
              <button className={classes.action}>
                <span className={classes.icon}><IconHelpSquareRounded stroke={1.5} /></span>
                <span className={classes.label}>{t('components.head.action.help')}</span>
              </button>
            </Popover.Target>
            <Popover.Dropdown></Popover.Dropdown>
          </Popover>
        ) : null}
      </div>
    )
    : null;

  return (
    <div className={classes.title}>
      {info}
      {actions}
    </div>
  );
};

Title.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.string,
  hideNews: PropTypes.bool,
  hideHelp: PropTypes.bool,
};

export default Title;
